module.exports = __webpack_public_path__ + "media/images/pic/lectors/agata-miks-lorenzoni-617f676c803a190c9c9ea6d8b3c4b4fc.jpeg";